import React, { useState, useEffect, useRef } from "react";
import Table from "../../Common/table";
import axios from "../../httpServices/httpService";
import api from "../../config.json";
import swal from "sweetalert";

import _, { cloneDeep, result } from "lodash";
import Loading from "../../utill/LoadingComponent";

import moment from "moment";

import PaginationComponent from "../../Common/PaginationComponent";

const WarningRegistered = ({
  handleDownloadTableToExcel,
  equips,
  equipGroups,
  fromDateLimit,
  Heading,
}) => {
  const reportType = [];
  const [qualityData, setQualityData] = useState([]);
  const [inputData, setInputData] = useState({
    From: new Date(),
    Till: new Date(),
  });
  const [types, setAllTypes] = useState([]);
  const [sortColumn, setSortColumn] = useState({
    path: "ToolId",
    order: "asc",
  });

  const [loader, setLoader] = useState(false);
  const [CurrentPage, setCurrentPage] = useState(1);
  const [TotalPage, setTotalPage] = useState(0);
  const [PageSize, setPageSize] = useState(50);

  useEffect(() => {
    Heading("Warnings Registered");
    GetAllInspetcionTypes();
  }, []);
    useEffect(() => {
      handleGetData();
    }, [CurrentPage, PageSize]);

  const handleOnChange = (name, value) => {
    const obj = { ...inputData };
    obj[name] = value;
    setInputData(obj);
  };

  const handleGetData = async () => {
    try {
      setLoader(true); // Show loader before making the API call

      const result = await axios.post(`${api.api}ChemicalCheckpointsLogs`, {
        ...{ query: "", PageSize: PageSize, Page: CurrentPage },
        ...inputData,
      });

      setLoader(false); // Hide loader after the API call

      if (result.data.data.length > 0) {
        console.log(result.data, "fjrgjbnkgj");
        setQualityData(result.data.data);
        setTotalPage(result.data.totalDocuments);
      } else {
        setQualityData([]); // Clear previous data
        swal("No Data Available");
      }
    } catch (err) {
      setLoader(false); // Ensure the loader is hidden on error
      console.error("Error fetching data:", err);

      if (err.response && err.response.data) {
        swal(err.response.data.message, { dangerMode: true });
      } else {
        swal("An unexpected error occurred.", { dangerMode: true });
      }
    }
  };

  const handleSort = (sortColumn) => {
    if (qualityData.length > 0) {
      const sorted = _.orderBy(
        qualityData,
        [sortColumn.path],
        [sortColumn.order]
      );
      setSortColumn(sortColumn);
      setQualityData(sorted);
    }
  };

  const columns1 = [
    {
      path: "DateTime",
      label: "Date",
      content: (obj) => <>{moment(obj.DateTime).format("DD-MM-YY")}</>,
    },
    {
      path: "DateTime",
      label: "Time",
      content: (obj) => <>{moment(obj.DateTime).format("hh:mm a")}</>,
    },
    { path: "CompoundCode", label: "Compound Code" },
    { path: "BatchCode", label: "Batch Code" },
    // { path: "Process", label: "Process" },

    { path: "AssetId", label: "Asset" },
    { path: "userId", label: "User Name"},

    { path: "message", label: "Message" },

    // {
    //     key: "view",
    //     label: "View Report",
    //     content: (obj) => (
    //         <React.Fragment>
    //             <button className='btn btn-secondary' onClick={() => {
    //                 const part = allPartsCache.find((part) => part.ItemName == obj.BatchCode && part.ItemNumber == obj.ItemNumber )
    //                 if (part) {
    //                     const checkSheet = part.Inspection.find(x => x.InspectionName == obj.InspectionType)
    //                     const template = checkPointTemplates.find(x => checkSheet && checkSheet.checkSheetTitle && x.Name == checkSheet.checkSheetTitle.TemplateName)
    //                     template.Columns = template.Columns.filter(x => x.EnableForDataEntry)
    //                     setSelectedTemplate(template)
    //                 }
    //                 setReportData(obj);
    //                 setOpen(true)
    //             }}>
    //                 <FontAwesomeIcon icon={faFile} />
    //             </button>
    //         </React.Fragment>
    //     ),
    // },
  ];

  const GetAllInspetcionTypes = () => {
    axios
      .get(api.api + "AssetMaster")
      .then((result) => {
        const reports = [...reportType];
        result.data.forEach((one) => {
          const obj = {
            label: one.AssetId,
            value: one.AssetId,
            name: one.AssetId,
          };
          reports.push(obj);
        });
        setAllTypes(reports);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  return (
    <React.Fragment>
      {loader ? <Loading labelShow={true} label={"Loading..."} /> : ""}

      <div className="row mx-2">
        <div className="col-sm-2">
          <div className="form-group">
            <label className="small m-0">From</label>
            <input
              value={moment(inputData.From).format("YYYY-MM-DD")}
              className="form-control form-control-sm"
              onChange={(e) => handleOnChange("From", e.currentTarget.value)}
              type="date"
            />
          </div>
        </div>
        <div className="col-sm-2">
          <div className="form-group">
            <label className="small m-0">Till</label>
            <input
              value={moment(inputData.Till).format("YYYY-MM-DD")}
              className="form-control form-control-sm"
              onChange={(e) => handleOnChange("Till", e.currentTarget.value)}
              type="date"
            />
          </div>
        </div>

        <div className="col-sm-2 py-4">
          <button
            className="btn btn-primary btn-sm "
            onClick={() => handleGetData()}
          >
            Apply
          </button>
        </div>
      </div>

      {qualityData.length > 0 ? (
        <Table
          id="RejectionDetailedAnalysispiechart"
          onSort={handleSort}
          columns={columns1}
          sortColumn={sortColumn}
          // data={extractInspectionDataSeparateArray(qualityData[0])}
          //   searchquery={true}
          //   handelSearch={handleGetData1}
          data={qualityData}
        />
      ) : (
        <Table
          id="RejectionDetailedAnalysispiechart"
          onSort={handleSort}
          columns={columns1}
          sortColumn={sortColumn}
          // data={extractInspectionDataSeparateArray(qualityData[0])}
          //   searchquery={true}
          //   handelSearch={handleGetData1}
          data={[]}
        />
      )}
      {qualityData && qualityData.length > 0 && (
        <div className="float-end m-3">
          <PaginationComponent
            defaultCurrent={CurrentPage}
            total={TotalPage}
            CurrentPageNumber={(currentpage, pagesize) => {
              setCurrentPage(currentpage);
              setPageSize(pagesize);
            }}
          />
        </div>
      )}
    </React.Fragment>
  );
};
export default WarningRegistered;
